import { redirect } from "react-router-dom";
import {
  apiLoader,
  bugzillaApiLoader,
  bugzillaApiLoaderForLayout,
} from "./apiLoader";

export const projectsLoader = async () => {
  const projects = await apiLoader("/projects");
  return { projects };
};

export const renewalsLoader = async () => {
  const projects = await apiLoader("/projects");
  return projects.filter((project) => {
    return project.remainingDays <= 30 && project.remainingDays !== null;
  });
};

export const pricingLoader = async () => {
  const pricings = await apiLoader("/pricings");
  const counters = await apiLoader("/counters");
  return { pricings, counters };
};

export const userLoader = async () => {
  const user = await apiLoader("/admins/user");
  return user;
};

export const dashboardLoader = async () => {
  const [admin, counters] = await Promise.all([
    userLoader(),
    apiLoader("/admin/counters"),
  ]);

  return { admin, counters };
};

export const paymentsLoader = async () => {
  const [paymentsData, countersData, spendPayments] = await Promise.all([
    apiLoader("/payments"),
    apiLoader("/admin/counters"),
    apiLoader("/paymentspends"),
  ]);
  return { paymentsData, countersData, spendPayments };
};

export const adminsLoader = async () => {
  const [adminsData, userData] = await Promise.all([
    apiLoader("/admins"),
    userLoader(),
  ]);
  const allowedRoles = new Set(["Administrator", "Founder"]);

  if (!allowedRoles.has(userData?.role)) {
    return redirect("/admin/dashboard");
  }
  return [adminsData, userData];
};

// Bugzilla Loaders

export const bugzillaBugsLoader = async () => {
  const bugsData = await bugzillaApiLoader("/bugs");
  return bugsData;
};

export const bugzillaDashboardLoader = async () => {
  const [statsData, bugsData] = await Promise.all([
    bugzillaApiLoader("/bugs/stats/counts"),
    bugzillaBugsLoader(),
  ]);
  return [statsData, bugsData];
};

export const bugzillUserLoader = async () => {
  const user = await bugzillaApiLoaderForLayout();
  return user;
};

export const bugzillAddUserLoader = async () => {
  const [bugzillaUsersData, user] = await Promise.all([
    bugzillaApiLoader("/bugzilla/auth/bugzilla-users"),
    bugzillaApiLoaderForLayout(),
  ]);
  const allowedRoles = new Set(["Administrator", "Founder"]);

  if (!allowedRoles.has(user?.role)) {
    return redirect(`/admin/bugzilla/user/${user._id}/dashboard`);
  }
  return [bugzillaUsersData, user];
};

export const bugzillBugCreateLoader = async () => {
  const users = await bugzillaApiLoader("/bugzilla/auth/bugzilla-users");
  return users;
};

export const bugzillBugViewLoader = async () => {
  const [users, bugsData] = await Promise.all([
    bugzillaApiLoader("/bugzilla/auth/bugzilla-users"),
    bugzillaBugsLoader(),
  ]);
  return [users, bugsData];
};
